import React, { useEffect } from "react"

const requiredAuth = Component => props => {
  const token = localStorage.getItem("token")

  useRedirectToLogin(token, props)

  return (
    <>
      <Component {...props} />
    </>
  )
}

const useRedirectToLogin = (token, props) => {
  useEffect(() => {
    if (token === "" && props.location.pathname !== "/login") {
      props.history.push("/login")
    } else if (!token) {
      localStorage.setItem("token", "")
      props.history.push("/login")
    } else if (props.location.pathname === "/login") {
      props.history.push("/")
    }
  }, [token, props])
}

export default requiredAuth
